.scrollableRow {
  display: grid;
  padding-left: 8px;
  padding-right: 8px;
  grid-gap: 8px;
  grid-auto-flow: column;
  grid-auto-columns: calc(100vw - 100px);
  padding-top: 1px;
  padding-bottom: 2px;
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
}
.scrollableRow::-webkit-scrollbar {
  display: none;
}
.scrollableRow > * {
  scroll-snap-align: start;
  scroll-margin: 0 0 0 8px;
  scroll-snap-margin: 0 0 0 8px;
}
@media (min-width: 768px) and (max-width: 1023px) {
  .scrollableRow {
    grid-auto-columns: calc(50vw - 75px);
  }
}
@media (max-width: 320px) {
  .scrollableRow {
    grid-auto-columns: calc(100vw - 50px);
  }
}
@media (min-width: 600px) and (max-width: 767px) {
  .scrollableRow {
    grid-auto-columns: 320px;
  }
}
@media (min-width: 1024px) {
  .scrollableRow {
    overflow-x: unset;
    padding: 0 16px;
    grid-auto-columns: 1fr;
  }
}
@media (max-width: 1023px) {
  .scrollableRow.noSidePadding {
    padding-left: 0;
    padding-right: 0;
  }
}
